export interface Category {
  key: string;
  name: string;
  desc: string;
  icon: string;
}

export const categories: Category[] = [
  {
    key: 'reverse',
    name: '爆料反转',
    desc: '剧情出现大转弯，先前的爆料被证伪或彻底改写',
    icon: 'ri-arrow-go-back-line',
  },
  {
    key: 'clarify',
    name: '辟谣澄清',
    desc: '当事方与相关机构发布说明，把误会一条条讲清楚',
    icon: 'ri-shield-check-line',
  },
  {
    key: 'followup',
    name: '真相后续',
    desc: '事件热度过去之后，持续追踪并还原完整经过',
    icon: 'ri-route-line',
  },
  {
    key: 'facepalm',
    name: '打脸现场',
    desc: '言之凿凿的判断，被后来公布的事实悄悄推翻',
    icon: 'ri-emotion-happy-line',
  },
  {
    key: 'observe',
    name: '舆情观察',
    desc: '从传播路径看一条爆料是如何被层层放大的',
    icon: 'ri-radar-line',
  },
];